function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { Empty, Spin, Tree } from 'antd';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { PeopleRoleSelectContext } from "../../../../context";
import "./RoleTree.css";
import { DataTree } from "./TreeNode";
var getAllDataList = function getAllDataList(tree) {
  var result = [];
  tree.forEach(function (item) {
    result.push(item);
    if (item.hasChildren) {
      result.push.apply(result, _toConsumableArray(getAllDataList(item.childNodes)));
    }
  });
  return result;
};
var RoleTree = function RoleTree(_ref) {
  var groupNodes = _ref.groupNodes,
    setGroupNodes = _ref.setGroupNodes,
    searchValue = _ref.searchValue;
  var _useContext = useContext(PeopleRoleSelectContext),
    needCustom = _useContext.needCustom,
    roleData = _useContext.roleData;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    roleTreeData = _useState2[0],
    setRoleTreeData = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 1),
    isLoading = _useState4[0];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    expandedKeys = _useState6[0],
    setExpandedKeys = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    autoExpandParent = _useState8[0],
    setAutoExpandParent = _useState8[1];
  var _useState9 = useState(),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedId = _useState10[0],
    setSelectedId = _useState10[1];
  var dataTree = useMemo(function () {
    return new DataTree(roleTreeData, false);
  }, [roleTreeData]);
  var dataTreeList = useMemo(function () {
    return getAllDataList(dataTree.nodes).filter(function (item) {
      return item.name.toLowerCase().indexOf((searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase()) || '') > -1;
    }).map(function (elem) {
      var strTitle = elem.name;
      var index = strTitle.toLowerCase().indexOf((searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase()) || '');
      var beforeStr = strTitle.substring(0, index);
      var afterStr = strTitle.slice(index + (searchValue || '').length);
      var name = index > -1 ? /*#__PURE__*/React.createElement("span", null, beforeStr, /*#__PURE__*/React.createElement("span", {
        className: "siteTreeSearchValue"
      }, strTitle.slice(index, index + (searchValue || '').length)), afterStr) : /*#__PURE__*/React.createElement("span", null, strTitle);
      return {
        key: elem.key,
        title: name
      };
    });
  }, [dataTree.nodes, searchValue]);
  var groupIds = useMemo(function () {
    return groupNodes.map(function (node) {
      return String(node.id);
    });
  }, [groupNodes]);
  var checkedKeysValue = useMemo(function () {
    var checkedKeys = [];
    groupNodes.forEach(function (item) {
      var nodeItem = dataTree.getNode(String(item.id));
      if (nodeItem) {
        checkedKeys.push.apply(checkedKeys, _toConsumableArray([].concat(_toConsumableArray(nodeItem.flattenChildNodes), [nodeItem]).map(function (elem) {
          return elem.key;
        })));
      }
    });
    return checkedKeys;
  }, [dataTree, groupNodes]);
  var updateGroupNode = function updateGroupNode(ids) {
    var node = [];
    ids.forEach(function (item) {
      var nodeItem = dataTree.getNode(item);
      if (nodeItem) {
        node.push({
          id: nodeItem.id,
          name: nodeItem.name,
          completeName: nodeItem.completeName
        });
      }
    });
    setGroupNodes(node);
  };
  useEffect(function () {
    if (Array.isArray(roleData)) {
      setRoleTreeData(needCustom ? roleData : roleData.filter(function (item) {
        return item.id !== 4;
      }));
    }
  }, [roleData]);
  return isLoading ? /*#__PURE__*/React.createElement("div", {
    className: "empty"
  }, /*#__PURE__*/React.createElement(Spin, {
    tip: "Loading",
    size: "default"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }))) : searchValue && dataTreeList.length > 0 || !searchValue && dataTree.data.length > 0 ? /*#__PURE__*/React.createElement(Tree, {
    checkable: true,
    blockNode: true,
    checkStrictly: true,
    selectedKeys: [selectedId || ''],
    expandedKeys: expandedKeys,
    autoExpandParent: autoExpandParent,
    onExpand: function onExpand(newExpandedKeys) {
      setExpandedKeys(newExpandedKeys);
      setAutoExpandParent(false);
    },
    checkedKeys: {
      checked: checkedKeysValue || [],
      halfChecked: []
    },
    treeData: searchValue ? dataTreeList : dataTree.data,
    onSelect: function onSelect(_selectedKeys, _ref2) {
      var selected = _ref2.selected,
        node = _ref2.node;
      if (selected) {
        setExpandedKeys([].concat(_toConsumableArray(expandedKeys), [node.key]));
        setSelectedId(node.key);
      } else {
        setExpandedKeys(expandedKeys.filter(function (item) {
          return item !== node.key;
        }));
        setSelectedId(void 0);
      }
    },
    onCheck: function onCheck(_checkedKeys, _ref3) {
      var _ref3$node = _ref3.node,
        key = _ref3$node.key,
        checked = _ref3$node.checked;
      var node = dataTree.getNode(key);
      if (!node) {
        return;
      }
      if (!checked) {
        updateGroupNode(Array.from(new Set([].concat(_toConsumableArray(groupIds), [node.key]))));
      } else {
        var _dataTree$getNode;
        var flattenChildNodes = node.flattenChildNodes.filter(function (item) {
          return _toConsumableArray(groupIds).includes(item.id);
        });
        var flattenChildNodesCheckKeys = flattenChildNodes.map(function (item) {
          return item.key;
        });
        flattenChildNodes.forEach(function (item) {
          flattenChildNodesCheckKeys.push.apply(flattenChildNodesCheckKeys, _toConsumableArray(item.childNodes.map(function (elem) {
            return elem.key;
          })));
        });
        var parents = ((_dataTree$getNode = dataTree.getNode(key)) === null || _dataTree$getNode === void 0 ? void 0 : _dataTree$getNode.parentNodes) || [];
        var parentsChecked = parents.filter(function (elem) {
          return checkedKeysValue.includes(elem.key);
        });
        var otherNodes = [];
        parentsChecked.forEach(function (item) {
          otherNodes.push.apply(otherNodes, _toConsumableArray(item.childNodes.filter(function (elem) {
            return checkedKeysValue.includes(elem.key);
          })));
        });
        var otherIds = otherNodes.filter(function (item) {
          return ![].concat(_toConsumableArray(parentsChecked), [node]).map(function (elem) {
            return elem.key;
          }).includes(item.key);
        }).map(function (tempNode) {
          return tempNode.key;
        });
        updateGroupNode(Array.from(new Set([].concat(_toConsumableArray(groupIds.filter(function (item) {
          return ![].concat(_toConsumableArray(parents.map(function (tempItem) {
            return tempItem.key;
          })), [key]).includes(item);
        })), _toConsumableArray(otherIds)))));
      }
    }
  }) : /*#__PURE__*/React.createElement(Empty, {
    description: /*#__PURE__*/React.createElement("div", {
      style: {
        color: '#C0C0C0'
      }
    }, "\u672A\u627E\u5230\u7ED3\u679C\uFF0C\u6362\u4E2A\u5173\u952E\u8BCD\u8BD5\u8BD5\u5427"),
    image: /*#__PURE__*/React.createElement("img", {
      src: "https://hwobs.fanruan.com/ui/search.png",
      style: {
        width: 160,
        height: 160
      }
    }),
    imageStyle: {
      height: 160
    }
  });
};
export default RoleTree;